<template>
    <div>
        <div class="bg"></div>
        <div class="pr">
            <div class="w1200 newBox">
                <el-menu :default-active="activeIndex" class="newNav pr" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="gdyy"><router-link to="/gygd/gdyy">公司简介</router-link></el-menu-item>
                    <el-menu-item index="zzjg"><router-link to="/gygd/zzjg">组织架构</router-link></el-menu-item>
                    <el-menu-item index="fzlc"><router-link to="/gygd/fzlc">发展历程</router-link></el-menu-item>
                    <el-menu-item index="zlfz"><router-link to="/gygd/zlfz">质量方针</router-link></el-menu-item>
                    <el-menu-item index="ldgh"><router-link to="/gygd/ldgh">领导关怀</router-link></el-menu-item>
                </el-menu>
            </div>
        </div>
        <router-view></router-view>
      
        <div class="gdyy">
            <router-view name="gdyy" :key="$route.fullPath"></router-view>
        </div>
        <div class="qyxwxq">
            <router-view name="qyxwxq" :key="$route.fullPath"></router-view>
        </div>
        <router-view name="zzjg" :key="$route.fullPath"></router-view>
        <router-view name="fzlc" :key="$route.fullPath"></router-view>
        <router-view name="zlfz" :key="$route.fullPath"></router-view>
        <router-view name="ldgh" :key="$route.fullPath"></router-view>
        <div v-for="(item) in value" :key="item.id" v-html="item.text"></div>
        <div>{{ value }}</div>
    </div>
</template>

<script>
import { request } from '../../assets/utils/request'

export default {
    data() {
        return {
            list: [],
            value: '',
            activeIndex: ''
        }
    },
    watch: {
        activeIndex(){
            var path = this.$route.path.split('/')
            this.activeIndex = path[2]
        }
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/news/news.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        },
        handleSelect() {

        },
        getActiveIndex() {
            var path = this.$route.path.split('/')
            if(path !== "" ){
                this.activeIndex = path[2]
            }else{
            }
        }
    },
    created(){
    },
    mounted() {
        this.getList();
        this.getActiveIndex();
    }
}
</script>

<style scoped>
    .bg{
        background: url('../../assets/images/bg.jpg') center center no-repeat;
        width: 100%;
        height: 400px;
    }
    .w1200.newBox{
        position: absolute;
        background: url('../../assets/images/nav.png') center center no-repeat;
        background-size: contain;
        height: 85px;
        top: -60px;
        left: 50%;
        margin-left: -600px;
    }
    .newBox .newNav{
        background: transparent;
        width: 680px;
        margin: 0 auto;
    }
    .newBox .newNav .el-menu-item{
        height: 95px!important;
        line-height: 95px!important;
        font-size: 16px;
        position: relative;
        top: -10px;
        width: 136px;
        text-align: center;
        color: #fff;
        padding: 0;
    }
    .newBox .newNav .el-menu-item:hover{
        background: #5bb62d;
        color: #fff!important;
    }
    .newBox .el-menu--horizontal>.el-menu-item.is-active{
        background: #5bb62d;
        color: #fff!important;
    }
    a{
        text-decoration: none;
    }
    .el-menu-item a{
        display: block;
        padding: 20 0;
    }
</style>